// extracted by mini-css-extract-plugin
var _1 = "LogsOverviewInfo_info__5vfY9";
var _2 = "LogsOverviewInfo_label__9rh-9";
var _3 = "LogsOverviewInfo_labelError__NA1sW";
var _4 = "LogsOverviewInfo_labelSecondary__89G5D";
var _5 = "LogsOverviewInfo_name__yNlZ5";
export { _1 as "info", _2 as "label", _3 as "labelError", _4 as "labelSecondary", _5 as "name" }
